import { createContext, useContext } from 'react';

// An embedded module uses the same authenticated routes and APIs with its own
// in-memory navigation. The outer school's workbench and browser URL stay put.
export const WorkbenchContext = createContext(null);
export const useWorkbenchContext = () => useContext(WorkbenchContext);
